import React from 'react'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../lib/ui/form'
import { RadioGroup, RadioGroupItem } from '../../lib/ui/radio-group'
import { cn } from '../../lib/utils'

export function MultipleChoiceField({
  name,
  label,
  choices,
  control,
  programSurvey = false,
}) {
  const fieldId = React.useId()

  const checkedStyles = programSurvey
    ? 'has-[:checked]:bg-primary has-[:checked]:text-primary-foreground'
    : 'has-[:checked]:border-primary has-[:checked]:bg-accent has-[:checked]:text-accent-foreground'

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const descriptionId = `${fieldId}-help`
        const errorId = `${fieldId}-error`
        const describedBy = fieldState.error
          ? `${descriptionId} ${errorId}`
          : descriptionId

        return (
          <FormItem className="flex flex-col">
            <FormLabel id={`${fieldId}-label`}>{label}</FormLabel>
            <FormDescription
              id={descriptionId}
              className="mt-4 text-sm text-[#5d5d5d]"
            >
              Select one option
            </FormDescription>
            <div className={programSurvey ? ' !mt-12' : ''}>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  value={field.value}
                  name={field.name}
                  aria-labelledby={`${fieldId}-label`}
                  aria-describedby={describedBy}
                  aria-invalid={fieldState.invalid}
                  className="flex flex-col rounded-md ring-offset-background transition-colors"
                >
                  {choices.map((choice, idx) => (
                    <div
                      className="items-left my-1 flex-grow space-x-3 space-y-0"
                      key={choice.value}
                    >
                      <label
                        htmlFor={`${fieldId}-${idx}-input`}
                        className={cn(
                          `flex cursor-pointer items-center rounded-md border border-[#b0b0b0] p-4 text-muted-foreground hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground has-[:focus-visible]:outline-none has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring has-[:focus-visible]:ring-offset-2 md:justify-center`,
                          checkedStyles,
                        )}
                      >
                        <RadioGroupItem
                          id={`${fieldId}-${idx}-input`}
                          className="sr-only"
                          value={choice.value}
                          aria-label={choice.label}
                          aria-describedby={describedBy}
                        />
                        {choice.label}
                      </label>
                    </div>
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
            <FormMessage id={errorId} aria-live="polite" />
          </FormItem>
        )
      }}
    />
  )
}
